var translations = {
    de: {
        postalCodeLabel: 'Postleitzahl des Objekts',
        postalCodePlaceholder: 'PLZ',
        cityLabel: 'Objektort',
        cityPlaceholder: 'Ort',
        streetLabel: 'Straße',
        streetPlaceholder: 'Straße',
        houseNumberLabel: 'Hausnummer',
        houseNumberPlaceholder: 'Nr',
    },
};
export default translations;
